import * as React from "react";

function FilterIcon(props) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 24 24"
			width="1em"
			height="1em"
			{...props}
		>
			<path
				fill="currentColor"
				d="M3 5.25A1.25 1.25 0 0 1 4.25 4h15.5a1.25 1.25 0 0 1 .94 2.07L14 13.62v4.88a1.25 1.25 0 0 1-.73 1.14l-2.5 1.14A1.25 1.25 0 0 1 9 19.64v-6.02L3.31 6.07A1.25 1.25 0 0 1 3 5.25"
			></path>
		</svg>
	);
}

export default FilterIcon;
